import { getResource } from "./request";

export async function getAllFundNames() {
  const endpoint = "common/GetOptions";
  const data = {
    option:"Fund"
  }

  const { response, error, code } = await getResource({ endpoint:endpoint, data:data });
  return { response, error, code };
}

export async function getAllChallengeNames() {
  const endpoint = "common/GetOptions";
  const data = {
    option:"Challenge"
  }

  const { response, error, code } = await getResource({ endpoint:endpoint, data:data });
  return { response, error, code };
}

export async function getChallengeNames(funds:number[]|string) {
  const endpoint = "GetChallengesShort";
  const data = {
    fund_id:funds,
  }

  const { response, error, code } = await getResource({ endpoint:endpoint, data:data });

  return { response, error, code };
}

export interface challengeNamesDataType {
  fund_id:number;
  fund_name:string;
  challenge_name:string;
  challenge_id:number
}